import { ResetQuestionsState } from './ResetQuestionsReducer';
function validate(form: ResetQuestionsState) {
  const { security } = form;
  const errors = [];
  if (!security[1].question) errors.push('s1q');
  if (!security[1].answer) errors.push('s1a');
  if (!security[2].question) errors.push('s2q');
  if (!security[2].answer) errors.push('s2a');
  if (!security[3].question) errors.push('s3q');
  if (!security[3].answer) errors.push('s3a');
  return errors;
}

export default validate;
